import { FieldLabel } from './FieldLabel'
import { InputOptionsProps } from './input-props'

const parseBgColor = (bgColor) => {
  switch (bgColor) {
    case 'white': {
      return 'border-primary-white bg-primary-white'
    }
    default: {
      return 'border-neutrals-base bg-neutrals-base'
    }
  }
}

export const FieldOption = (props = InputOptionsProps) => {
  const { label, name, value, required, onChange, options, bgColor, customType = 'default' } = props
  return (
    <div className={'flex w-full flex-col gap-2'}>
      <FieldLabel {...{ label, hasInput: !!value, required }} />
      <div className={`relative flex min-h-11 flex-row rounded-3xl border-4 border-solid ${parseBgColor(bgColor)}`}>
        {options.map((option) => {
          const selectedOption = option.value === value
          return (
            <div
              className={`relative flex min-h-11 w-full items-center justify-center rounded-3xl text-center transition-colors ${
                selectedOption ? 'bg-secondary-green text-primary-white' : 'text-black opacity-60'
              }`}
              key={option.label}
            >
              <input
                onChange={onChange}
                name={name}
                value={option.value}
                type="checkbox"
                data-custom-type={customType}
                className={'absolute inset-0 z-10 h-full w-full cursor-pointer appearance-none opacity-0 '}
              />
              <div className={'paragraph-sm text-center font-bold'}>{option.label}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
